export default [
  {
    path: "/radiology",
    name: "radiology",
    component: () => import("@/views/radiology/Radiology.vue"),
  },
  {
    path: "/patient-card-radiology",
    name: "patient-card-radiology",
    component: () => import("@/views/radiology/PatientCardRadiology.vue"),
  },
  {
    path: "/patient-radiology",
    name: "patient-radiology",
    component: () => import("@/views/radiology/PatientRadiology.vue"),
  },
  {
    path: "/patient-radiology",
    name: "patient-radiology",
    component: () => import("@/views/radiology/PatientRadiology.vue"),
  },
  {
    path: "/patient-radiology-details/:id",
    name: "patient-radiology-details",
    component: () => import("@/views/radiology/PatientRadiologyDetails.vue"),
  },
  {
    path: "/patient-radiology-attachments/:cardId",
    name: "patient-radiology-attachments",
    component: () => import("@/views/radiology/PatientRadiologyAttachments.vue"),
  },
  {
    path: "/patient-radiology-list",
    name: "patient-radiology-list",
    component: () => import("@/views/radiology/patients.vue"),
  },
];
